(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pneupret-demo-video"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pp-video-player').forEach(function(player){var video=player.querySelector('video'),button=player.querySelector('.pp-video-play');button.addEventListener('click',function(){video.controls=true;var play=video.play();if(play)play.catch(function(){button.hidden=false;});});video.addEventListener('play',function(){button.hidden=true;});video.addEventListener('pause',function(){button.hidden=false;});video.addEventListener('ended',function(){button.hidden=false;});
if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(!entry.isIntersecting&&!video.paused)video.pause();});},{threshold:0});observer.observe(video);}
document.addEventListener('visibilitychange',function(){if(document.hidden&&!video.paused)video.pause();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pneupret-purchase"] && !Shopify.designMode) return;
  try {
    (function(){
  var panels=document.querySelectorAll('[data-purchase-panel]');
  panels.forEach(function(panel){
    if(panel.dataset.ready==='1')return;
    panel.dataset.ready='1';
    var form=panel.querySelector('.pc-form');
    var qty=panel.querySelector('[name="quantity"]');
    var minus=panel.querySelector('[data-qty-minus]');
    var plus=panel.querySelector('[data-qty-plus]');
    var buy=panel.querySelector('.pc-buy-now');
    var add=panel.querySelector('.pc-add');
    var status=panel.querySelector('.pc-status');
    var total=panel.querySelector('[data-total-price]');
    var compareTotal=panel.querySelector('[data-total-compare]');
    var sticky=panel.querySelector('.pc-sticky');
    var stickyBuy=panel.querySelector('[data-sticky-buy]');
    var stickyPrice=panel.querySelector('[data-sticky-price]');
    var unit=Number(panel.dataset.unitPrice||0);
    var compareUnit=Number(panel.dataset.compareUnitPrice||unit);
    var busy=false;

    function clampQty(){
      var n=parseInt(qty.value||'1',10);
      if(!Number.isFinite(n))n=1;
      n=Math.max(1,Math.min(10,n));
      qty.value=n;
      return n;
    }
    function money(cents){
      try{return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(cents/100)}
      catch(e){return (cents/100).toFixed(2).replace('.',',')+' €'}
    }
    function refresh(){
      var n=clampQty();
      if(total)total.textContent=money(unit*n);
      if(compareTotal)compareTotal.textContent=money(compareUnit*n);
      if(stickyPrice)stickyPrice.textContent=money(unit*n);
    }
    minus.addEventListener('click',function(){qty.value=clampQty()-1;refresh()});
    plus.addEventListener('click',function(){qty.value=clampQty()+1;refresh()});
    qty.addEventListener('input',refresh);
    refresh();

    async function addItem(intent,button){
      if(busy||button.disabled)return;
      busy=true;
      status.textContent='';
      var original=button.querySelector('span')?button.querySelector('span').textContent:button.textContent;
      if(button.querySelector('span'))button.querySelector('span').textContent=button.dataset.loading||'Chargement…';
      else button.textContent=button.dataset.loading||'Chargement…';
      buy.disabled=true;add.disabled=true;if(stickyBuy)stickyBuy.disabled=true;
      try{
        var response=await fetch(button.dataset.cartAdd||buy.dataset.cartAdd,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(form.querySelector('[name="id"]').value),quantity:clampQty()}]})
        });
        if(!response.ok)throw new Error('cart');
        window.location.assign(intent==='checkout'?(button.dataset.checkout||'/checkout'):(button.dataset.cart||add.dataset.cart));
      }catch(error){
        status.textContent=button.dataset.error||'Une erreur est survenue. Réessayez.';
        if(button.querySelector('span'))button.querySelector('span').textContent=original;else button.textContent=original;
        busy=false;buy.disabled=false;add.disabled=false;if(stickyBuy)stickyBuy.disabled=false;
      }
    }

    form.addEventListener('submit',function(event){
      event.preventDefault();
      var submitter=event.submitter||add;
      var intent=submitter.dataset.intent||'cart';
      addItem(intent,submitter);
    });
    if(stickyBuy)stickyBuy.addEventListener('click',function(){addItem('checkout',buy)});

    if(sticky && 'IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var passed=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;
          sticky.hidden=!passed;
          document.body.classList.toggle('pc-sticky-on',passed);
        });
      },{threshold:0});
      observer.observe(buy);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pneupret-reviews"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pp-reviews').forEach(function(section){var dialog=section.querySelector('.pp-review-lightbox');section.querySelectorAll('.pp-review-photo').forEach(function(link){link.addEventListener('click',function(event){if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;event.preventDefault();var image=dialog.querySelector('img'),original=link.querySelector('img');image.width=original.width;image.height=original.height;image.src=link.href;dialog.showModal();});});dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});});
  } catch(e) { console.error(e); }
})();

})();
